import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@src/shared/modal/modal.service';
import { AdServerService } from '../../../woo_services.module/AdServerService';
import { CampaignService } from '../../../woo_services.module/CampaignService';
import { RoutingService } from '../../../woo_services.module/RoutingService';
import { TranslationService } from '../../../woo_services.module/TranslationService';
import { Campaign } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'review-campaign',
  templateUrl: './review-campaign.component.html',
  standalone: false,
})
export class ReviewCampaign {
  campaign: Campaign;
  firstCreative: any;
  assetUrl: string;
  reviewStatus: 'rejected' | 'approved';
  rejectMessage: string;

  constructor(
    private adServerService: AdServerService,
    private modalService: ModalService,
    private translationService: TranslationService,
    private campaignService: CampaignService,
    private route: ActivatedRoute,
    protected routingService: RoutingService,
  ) {
    campaignService.get(routingService.getParam(this.route, 'id')).then((campaign) => {
      this.campaign = campaign;
      this.firstCreative = campaign.targetings[0].creatives[0];
      this.assetUrl = this.firstCreative.asset_url;
    });
  }

  submitForm = async (): Promise<void> => {
    if (this.reviewStatus === 'approved') {
      await this.approveCampaign();
    } else {
      await this.rejectCampaign();
    }
  };

  rejectCampaign = async (): Promise<void> => {
    const loaderModal = this.modalService.openLoader('Nekar kampanj...');
    const campaign = await this.campaignService.reviewCampaign(this.campaign.id, this.reviewStatus, this.rejectMessage);
    this.modalService.openSuccess(
      'Kom ihåg att skicka ett mail till kunden med anledningen till att den nekades.',
      'Anledningen du angav var: ' + this.rejectMessage,
    );
    loaderModal.close();
    await this.routingService.goToDashboardWithCampaign(campaign.id);
  };

  approveCampaign = async (): Promise<void> => {
    const loaderModal = this.modalService.openLoader('Godkänner kampanj och skickar till adservern...');

    try {
      await Promise.all([
        this.campaignService.reviewCampaign(this.campaign.id, this.reviewStatus, this.rejectMessage),
        this.campaignService.updateCreatives(this.campaign.id, this.campaign.targetings[0].id, [this.firstCreative]),
      ]);
    } catch (err) {
      loaderModal.close();
      // HTTP errors are shown by the global error handler, failed jobs are not
      if (!(err instanceof HttpErrorResponse)) {
        const reason = err.error?.error ? [this.translationService.convertError(err.error.error)] : [];
        this.modalService.openError('Kunde inte godkänna kampanjen.', ...reason);
      }
      return;
    }
    await this.adServerService.sendCampaign(this.campaign.id);
    try {
      this.modalService.openSuccess(
        'Kampanjen har godkänts och skickats till adservern',
        'Kom ihåg att skicka ett mail till kunden.',
      );
      await this.routingService.goToDashboardWithCampaign(this.campaign.id);
    } catch (errorResponse) {
      const msg = this.translationService.convertSendToAdserverError(errorResponse.error);
      this.modalService.openError(msg);
    } finally {
      loaderModal.close();
    }
  };
}
